<template>
  <div id="app">
    <div
      id="navigation"
      class="fixed-top"
      :class="{ 'transparent': scrollPosition < 100, 'bg-primary': scrollPosition > 100 }"
    >
      <div id="status-bar" class="container-fluid">
        <div class="row">
          <div class="col-md-3 col-lg-2 offset-md-9 offset-lg-10">
            <div class="wrap float-right">
              <div class="social-media">
                <a href="https://www.facebook.com/monitoring.mons/" target="_blank">
                  <i class="fa fa-facebook-official" aria-hidden="true"></i>
                </a>
                <a href="https://twitter.com/monitoring_MONS" target="_blank">
                  <i class="fa fa-twitter-square" aria-hidden="true"></i>
                </a>
              </div>
              <div class="languages">
                <a
                  v-if="currentLanguage === 'sr'"
                  href="#"
                  v-on:click.prevent="changeLanguage"
                >English</a>
                <a
                  v-if="currentLanguage === 'en'"
                  href="#"
                  v-on:click.prevent="changeLanguage"
                >Srpski</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav class="navbar navbar-toggleable-md navbar-inverse">
        <button
          class="navbar-toggler navbar-toggler-right"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <!-- <a class="navbar-brand" href=""> -->
        <router-link :to="{name: 'home'}" class="navbar-brand" tag="a">
          <img src="./assets/logo.svg" alt="MONS platforma" />
        </router-link>
        <!-- </a> -->
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <div class="navbar-nav">
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link :to="{name: 'home'}" class="nav-link" exact>{{ $t('navigation.home') }}</router-link>
            </li>

            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                :class="this.$route.path.includes('/about') ? 'router-link-active' : ''"
              >MONS</a>
              <div
                class="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <router-link
                  :to="{name: 'about'}"
                  class="dropdown-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                >{{ $t('navigation.about') }}</router-link>
                <router-link
                  :to="{name: 'initiators'}"
                  class="dropdown-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                >{{ $t('navigation.initiators') }}</router-link>
                <!-- <router-link
                  :to="{name: 'management'}"
                  class="dropdown-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                >{{ $t('navigation.management') }}</router-link> -->
                <router-link
                  :to="{name: 'aboutAuthors'}"
                  class="dropdown-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                >{{ $t('navigation.aboutAuthors') }}</router-link>
              </div>
            </li>

            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link
                :to="{name: 'key_articles'}"
                class="nav-link"
              >{{ $t('navigation.key_articles') }}</router-link>
            </li>

            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link :to="{name: 'blog'}" class="nav-link">{{ $t('navigation.blog') }}</router-link>
            </li>

            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link :to="{name: 'video'}" class="nav-link">{{ $t('navigation.video') }}</router-link>
            </li>

            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link
                :to="{name: 'infographics'}"
                class="nav-link"
              >{{ $t('navigation.infographics') }}</router-link>
            </li>

            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link :to="{name: 'contact'}" class="nav-link">{{ $t('navigation.contact') }}</router-link>
            </li>

            <search-component
              id="search"
              :class="{ 'transparent': scrollPosition < 100, '': scrollPosition > 100 }"
            ></search-component>
          </div>
        </div>
      </nav>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid main-content">
      <transition name="fade">
        <router-view
          :chapter="currentChapter"
          :language="currentLanguage"
          :chapters="chapters"
          @chapterChanged="chapterChanged"
          @languageChanged="languageChanged"
        ></router-view>
      </transition>
    </div>

    <footer-view></footer-view>
  </div>
</template>

<script>
import Vue from 'vue'
import FooterView from './components/ui/Footer'
import SearchComponent from './components/ui/SearchComponent'

export default {
  name: 'app',
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: 'MONS - %s'
    }
  },
  components: {
    FooterView,
    SearchComponent
  },
  data: function() {
    return {
      chapters: [],
      currentChapter: undefined,
      currentLanguage: 'sr',
      scrollPosition: null,
      title: this.$t('title.landing')
    }
  },
  created: function() {
    this.getChapters()

    window.addEventListener('scroll', this.handleScroll)
    this.$on('chapterChanged', function(value) {
      this.chapterChanged(value)
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll: function() {
      this.scrollPosition = window.scrollY
    },
    chapterChanged: function(chapterId) {
      if (this.chapters.length === 0) {
        return
      }

      for (let chapter of this.chapters) {
        if (chapter.id === chapterId) {
          this.currentChapter = chapter
          return
        }
      }

      console.log("Didn't find any")
    },
    languageChanged: function(language) {
      this.currentLanguage = language
    },
    getChapters: function() {
      this.$http
        .get('chapters', {
          params: {
            lang: this.$lang
          }
        })
        .then(
          response => {
            this.chapters = response.body
            this.currentChapter = this.chapters[0]
          },
          response => {
            console.error(response.body)
          }
        )
    },
    openSelect: function() {
      var e = document.createEvent('MouseEvents')
      e.initMouseEvent('mousedown')
      document.getElementById('lang-select').dispatchEvent(e)
    },
    changeLanguage: function() {
      if (this.currentLanguage === 'sr') {
        this.currentLanguage = 'en'
      } else {
        this.currentLanguage = 'sr'
      }
    }
  },

  events: {
    chapterChanged: function(chapterId) {
      if (this.chapters.length === 0) {
        return
      }

      for (let chapter in this.chapters) {
        if (chapter.id === chapterId) {
          this.currentChapter = chapter
          return
        }
      }
    }
  },

  watch: {
    currentLanguage: function() {
      Vue.config.lang = this.currentLanguage
      this.title = this.$t('title.landing')
      this.getChapters()
    }
  }
}
</script>

<style lang="scss">
@import 'styles/_vars.scss';

html {
  height: 100%;
  padding: 0;
  margin: 0;
}

body {
  height: 100%;
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  background: $bg-color;
}

h1,
h2 {
  color: $txt-color-heading;
  font-weight: $semibold;
}

.page-title {
  padding-top: 1rem;
  padding-bottom: 2rem;
}

.section-title {
  text-transform: uppercase;
  color: $primary-color;
  font-weight: $bold;
  font-size: 0.8rem;
  letter-spacing: $letter-spacing-section-title;
}

#app {
  height: 100%;
} // Navigation
#navigation {
  transition: all 0.15s;

  .nav-link {
    color: white;
  }
  .nav-link.router-link-active {
    font-weight: $bold;
  }

  &.bg-primary {
    background: rgba($primary-color, 0.95);
    background-color: rgba($primary-color, 0.95) !important;

    #status-bar {
      transition: all 0.15s;
      background: darken($primary-color, 5%);
      * {
        color: white;
      }

      @media (max-width: $device-sm) {
        display: none;
      }
    }
  }

  &.transparent {
    background: transparent;
    background-color: transparent;
  }

  .navbar-collapse {
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
  }

  .navbar-brand img {
    height: 2rem;
    display: inline-block;
  }

  #search {
    margin-left: 1rem;
    position: relative;
    top: 2px;
  }

  @media (max-width: $device-md) {
    background: rgba($primary-color, 0.95) !important;
    background-color: rgba($primary-color, 0.95) !important;

    #search {
      display: block;
      width: 100%;
      margin-left: 0;
      margin-bottom: 1rem;
    }
  }
} // Status bar
#status-bar {
  padding: 0.3rem 1.2rem;
  background: white;

  .social-media,
  .languages {
    display: inline-block;
  }

  .social-media {
    margin-right: 0.25rem;

    i {
      line-height: 1;
      font-size: 1.25rem;
      margin-right: 0.25rem;

      &.fa-facebook-official {
        color: $facebook;
        &:hover {
          color: lighten($facebook, 10%);
        }
      }
      &.fa-twitter-square {
        color: $twitter;
        &:hover {
          color: lighten($twitter, 10%);
        }
      }
    }
  }

  .languages {
    position: relative;
    top: -2px;

    a {
      text-transform: uppercase;
      font-weight: $bold;
      color: $primary-color;
      font-size: 0.75rem;

      &:hover {
        text-decoration: none;
      }
    }
  }
}

.main-content {
  min-height: 80%;
  padding: 0;
  display: block;
}

.empty {
  text-transform: uppercase;
  font-size: 1rem;
  letter-spacing: 3px;
  font-weight: $bold;
  color: darken($bg-color, 15%);
} // UI
// Tootlips
.ttip {
  position: relative;
  display: inline;
  line-height: 1;
  color: $primary-color;
  font-weight: $semibold;
  cursor: help;

  .ttip-text {
    visibility: hidden;
    opacity: 0;
    padding: 0.5rem 0.75rem;
    position: absolute;
    max-width: 80vw;
    min-width: 20vw;
    width: auto;
    bottom: 90%;
    left: 0%;
    z-index: 1;
    line-height: 1.8;

    background-color: #464646;
    background: rgba(40, 40, 40, 1);
    color: $white;
    text-align: left;
    font-weight: $normal;
    font-size: 0.75rem;
    border-radius: $border-radius-standard;

    transition: all 150ms;

    a {
      color: $secondary-color;
    }
  }

  &:hover {
    .ttip-text {
      bottom: 110%;
      opacity: 1;
      visibility: visible;
    }
  }
} // Dropdowns
.dropdown {
  .dropdown-menu {
    display: block;
    visibility: hidden;
    opacity: 0;
    padding: 0;
    overflow: hidden;
    top: 80%;
    border: none;
    border-bottom: 4px solid $primary-color;
    transition: all 150ms;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    font-size: 0.9rem;

    a {
      padding: 0.5rem 1rem;
      border-bottom: 1px solid lighten($secondary-color, 15%);

      &:active {
        background: $primary-color;
        color: $white;
      }

      &:hover {
        background: lighten($secondary-color, 20%);
      }
    }
  }

  &.show {
    .dropdown-menu {
      visibility: visible;
      opacity: 1;
      top: 100%;
    }
  }

  @media (max-width: $device-md) {
    .dropdown-menu {
      display: none;
      height: 0;
      border-bottom: none;

      a:hover {
        background: darken(white, 5%);
      }
    }
    &.show {
      .dropdown-menu {
        display: block;
        height: auto;
      }
    }
  }
} // ANIMATIONS
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.2s;
}

.fade-enter-active {
  transition-delay: 0.2s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?9e38644c